
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/complaints",
      function () {
        return require("private-next-pages/contact-us/complaints.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us/complaints"])
      });
    }
  